import React from 'react';

interface IconProps {
  size?: number;
  color?: string;
  fill?: string;
  className?: string;
  strokeWidth?: number;
}

export const CircleIcon: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  fill,
  className = '',
  strokeWidth = 1.5,
}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <circle
      cx='10'
      cy='10'
      r='8'
      stroke={color}
      strokeWidth={strokeWidth}
      fill='none'
    />
    <circle cx='10' cy='10' r='3' fill={fill || color} />
  </svg>
);
